import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import React from "react";
import { Route, Switch, useHistory, useRouteMatch } from "react-router";
import { CreateView, IndexView, withBreadCrumbs } from "lego-gui-lib/lib";
import { HuntingGroupSchemaColumns, HuntingGroupSchemaForm } from "./schema";
import {
  TabContentContainer,
  TabTitleContainer,
  TabViewContainer
} from "../../common/tabContainers";
import { HuntingGroupShowView } from "./HuntingGroupShowView";
import { ParentRoute } from "../../core/model/parent";
import { useFirstValue } from "../../common/common";

export const HuntingGroupViewComponent = () => {
  const match = useRouteMatch();
  const baseUrl = match.path;
  return (
    <>
      <ParentRoute dataSourceName={"huntingGroup"} path={baseUrl + "/:id"} />
      <Switch>
        <Route exact={true} path={baseUrl} component={Index} />
        <Route path={baseUrl + "/create/:id"} component={Clone} />
        <Route path={baseUrl + "/create"} component={Create} exact={true} />
        <Route path={baseUrl + "/:id"} component={HuntingGroupShowView} />
      </Switch>
    </>
  );
};

const injectDataSource = (comp: any) =>
  inject("huntingGroup", "i18n", "SAN", "router")(observer(comp));

export const Index = injectDataSource(
  ({ huntingGroup, i18n, SAN, ...rest }: any) => {
    const title = i18n.t("hns:huntingGroup:domain", { count: 2 });
    return (
      <IndexView
        dataSource={huntingGroup.listDataSource}
        {...rest}
        title={title}
        titleVariant={"h5"}
        toolbarButtons={{ delete: true, export: true }}
        rowButtons={{ edit: true, delete: true, copy: true, export: true }}
        columns={HuntingGroupSchemaColumns(SAN)}
        titleContainer={TabTitleContainer}
        viewContainer={TabViewContainer}
        contentContainer={TabContentContainer}
      />
    );
  }
);

export const Create = injectDataSource(
  ({ huntingGroup, i18n, SAN, match, ...rest }: any) => {
    const title = i18n.t("common:create", {
      domain: "hns:huntingGroup:domain"
    });
    const history = useHistory();
    return withBreadCrumbs(
      { to: match.url, children: title },
      <CreateView
        dataSource={huntingGroup.oneDataSource}
        {...rest}
        title={title}
        initialValues={{
          huntingType: 0,
          queueActive: 0
        }}
        fields={HuntingGroupSchemaForm(SAN)}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);

export const Clone = injectDataSource(
  ({ huntingGroup, i18n, SAN, match, ...rest }: any) => {
    const name = useFirstValue(huntingGroup.oneDataSource.one, ds => ds.name);
    const title = i18n.t("common:copyTitle", {
      domain: "hns:huntingGroup:domain",
      id: name
    });
    const history = useHistory();
    return withBreadCrumbs(
      { to: match.url + "/edit", children: i18n.t("common:copy") },
      <CreateView
        submit={async () => {
          return huntingGroup.oneDataSource.clone();
        }}
        dataSource={huntingGroup.oneDataSource}
        {...rest}
        title={title}
        fields={HuntingGroupSchemaForm(SAN)}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);
